import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import toast from "react-hot-toast";
import {
  exportExcelFromApi,
  exportExcelLocal,
  exportFile,
} from "../../utils/tools";
import { useLocking } from "../../hooks/useLooking";
import { apartmentCall } from "../../api/apartment";
import { commissionAnalystCall } from "../../api/commissionAnalyst";
import { memo } from "react";
import SearchableSelect from "../../components/selectForm";
import DatePicker from "react-datepicker";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import { useCategories } from "../../categorys/locking/index";
import IconX from "../../assets/images/booking/x-circle.svg";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { useNavigate } from "react-router-dom";

const columnMappingReverse = {
  "Ngày đối chiếu": "matchingDate",
  "Dự án": "project",
  "Ngày KH chuyển tiền/Ngày cọc": "transactionDate",
  "Hệ số dự án (K)": "kRate",
  "Quỹ căn": "fundApartment",
  "Mã lô": "codeApartment",
  "Diện tích": "length",
  TTDA: "ttda",
  "Giá tính PDV": "pricePdv",
  NCC: "totalStandardWorking",
  "Tỷ lệ GD": "rateTransaction",
  "Tỉ lệ TN MSH (Đi kèm K) (%)": "rateTNMSH",
  "Tỉ lệ TN sàn (%)": "rateTN",
  "Tỷ lệ PDV CVKD": "rateCVKD",
  "Tỷ lệ PDV CVKD Elite": "rateCVKDElite",
  "Tỷ lệ Sale 1": "rateSale1",
  "Mã Sale 1": "codeSale1",
  "Họ tên sale bán trực tiếp 1": "nameSale1",
  "Chức vụ Sale 1": "jobTitleSales1",
  "NCTT Sale 1": "ncttSale1",
  "Điểm ĐG Sale 1": "pointSale1",
  "Thưởng nóng Sale 1": "bonusSale1",
  "Chứng chỉ/ ký quỹ của Sale 1": "certificateOrDepositSale1",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 1":
    "accountingFromPreviousPeriodOrAdvanceSale1",
  "Số tiền TN MSH (đi kèm K) Sale 1": "priceTNMSHSale1",
  "Số tiền TN Sàn Sale 1": "priceTNSale1",
  "Số tiền PDV CVKD Sale 1": "priceCVKDSale1",
  "Số tiền PDV CVKD Elite Sale 1": "priceCVKDEliteSale1",
  "Tỷ lệ Sale 2": "rateSale2",
  "Mã Sale 2": "codeSale2",
  "Họ tên sale bán trực tiếp 2": "nameSale2",
  "Chức vụ Sale 2": "jobTitleSales2",
  "NCTT Sale 2": "ncttSale2",
  "Điểm ĐG Sale 2": "pointSale2",
  "Thưởng nóng Sale 2": "bonusSale2",
  "Chứng chỉ/ ký quỹ của Sale 2": "certificateOrDepositSale2",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 2":
    "accountingFromPreviousPeriodOrAdvanceSale2",
  "Số tiền TN MSH (đi kèm K) Sale 2": "priceTNMSHSale2",
  "Số tiền TN Sàn Sale 2": "priceTNSale2",
  "Số tiền PDV CVKD Sale 2": "priceCVKDSale2",
  "Số tiền PDV CVKD Elite Sale 2": "priceCVKDEliteSale2",
  "Tổng TN Sale": "totalTNSale",
  "Tổng PDV Sale": "totalRoseSale",
  "Mã GDKĐH": "codeGDKDH",
  "Họ và tên GDKĐH": "nameGDKDH",
  "Tỷ lệ PDV GDKĐH": "rateGDKDH",
  "NCTT GDKĐH": "ncttGDKDH",
  "Điểm ĐG GDKĐH": "pointGDKDH",
  "Thưởng nóng GDKĐH": "bonusGDKDH",
  "Chứng chỉ/ ký quỹ của GDKĐH": "certificateOrDepositGDKDH",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐH":
    "accountingFromPreviousPeriodOrAdvanceGDKDH",
  "Số tiền GDKĐH": "priceGDKDH",
  "Mã GDKĐT": "codeGDKDT",
  "Họ và tên GDKĐT": "nameGDKDT",
  "Tỷ lệ PDV GDKĐT": "rateGDKDT",
  "NCTT GDKĐT": "ncttGDKDT",
  "Điểm ĐG GDKĐT": "pointGDKDT",
  "Thưởng nóng GDKĐT": "bonusGDKDT",
  "Chứng chỉ/ ký quỹ của GDKĐT": "certificateOrDepositGDKDT",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐT":
    "accountingFromPreviousPeriodOrAdvanceGDKDT",
  "Số tiền GDKĐT": "priceGDKDT",
  "Mã GDKCL": "codeGDKCL",
  "Họ và tên GDKCL": "nameGDKCL",
  "Tỷ lệ PDV GDKCL": "rateGDKCL",
  "NCTT GDKCL": "ncttGDKCL",
  "Điểm ĐG GDKCL": "pointGDKCL",
  "Thưởng nóng GDKCL": "bonusGDKCL",
  "Chứng chỉ/ ký quỹ của GDKCL": "certificateOrDepositGDKCL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKCL":
    "accountingFromPreviousPeriodOrAdvanceGDKCL",
  "Số tiền GDKCL": "priceGDKCL",
  "Tỷ lệ PDV GĐK": "rateGDK",
  "Số tiền GĐK": "priceGDK",
  "Mã GDVĐH": "codeGDVDH",
  "Họ và tên GDVĐH": "nameGDVDH",
  "Tỷ lệ PDV GDVĐH": "rateGDVDH",
  "NCTT GDVĐH": "ncttGDVDH",
  "Điểm ĐG GDVĐH": "pointGDVDH",
  "Thưởng nóng GDVĐH": "bonusGDVDH",
  "Chứng chỉ/ ký quỹ của GDVĐH": "certificateOrDepositGDVDH",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐH":
    "accountingFromPreviousPeriodOrAdvanceGDVDH",
  "Số tiền GDVĐH": "priceGDVDH",
  "Mã GDVĐT": "codeGDVDT",
  "Họ và tên GDVĐT": "nameGDVDT",
  "Tỷ lệ PDV GDVĐT": "rateGDVDT",
  "NCTT GDVĐT": "ncttGDVDT",
  "Điểm ĐG GDVĐT": "pointGDVDT",
  "Thưởng nóng GDVĐT": "bonusGDVDT",
  "Chứng chỉ/ ký quỹ của GDVĐT": "certificateOrDepositGDVDT",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐT":
    "accountingFromPreviousPeriodOrAdvanceGDVDT",
  "Số tiền GDVĐT": "priceGDVDT",
  "Mã GĐVCL": "codeGDVCL",
  "Họ và tên GĐVCL": "nameGDVCL",
  "Tỷ lệ PDV GĐVCL": "rateGDVCL",
  "NCTT GĐVCL": "ncttGDVCL",
  "Điểm ĐG GĐVCL": "pointGDVCL",
  "Thưởng nóng GĐVCL": "bonusGDVCL",
  "Chứng chỉ/ ký quỹ của GĐVCL": "certificateOrDepositGDVCL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GĐVCL":
    "accountingFromPreviousPeriodOrAdvanceGDVCL",
  "Số tiền GĐVCL": "priceGDVCL",
  "Tỷ lệ PDV GĐV": "rateGDV",
  "Số tiền GĐV": "priceGDV",
  "Mã GTĐL": "codeGTDL",
  "Họ và tên GTĐL": "nameGTDL",
  "Tỷ lệ PDV/Số tiền hưởng GTĐL": "rateGTDL",
  "NCTT GTĐL": "ncttGTDL",
  "Điểm ĐG GTĐL": "pointGTDL",
  "Thưởng nóng GTĐL": "bonusGTDL",
  "Chứng chỉ/ ký quỹ của GTĐL": "certificateOrDepositGTDL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GTĐL":
    "accountingFromPreviousPeriodOrAdvanceGTDL",
  "Số tiền GTĐL": "priceGTDL",
  "Mã TGĐ": "codeTGD",
  "Họ và tên TGĐ": "nameTGD",
  "NCTT TGĐ": "ncttTGD",
  "Tỷ lệ PDV TGĐ": "rateTGD",
  "Thưởng nóng TGĐ": "bonusTGD",
  "Chứng chỉ/ ký quỹ của TGĐ": "certificateOrDepositTGD",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác TGĐ":
    "accountingFromPreviousPeriodOrAdvanceTGD",
  "Số tiền TGĐ": "priceTGD",
  "Tỷ lệ PDV": "rate",
  "Số tiền": "price",
  "Tháng đối chiếu": "monthYear",
};

const columnMappingReverseCalculator = {
  "Mã lô": "codeApartment",
  TTDA: "ttda",
  "Tỉ lệ thưởng nóng sàn": "rateTNSan",
  "Số tiền TN sàn": "priceTNSan",
  "Tỉ lệ nhận về": "transactionRate",
  "Tỷ lệ Sale 1": "rateSale1",
  "Mã Sale 1": "codeSale1",
  "Họ tên sale bán trực tiếp 1": "nameSale1",
  "Thưởng nóng Sale 1": "bonusSale1",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 1":
    "accountingFromPreviousPeriodOrAdvanceSale1",
  "Thuế TNCN Sale 1": "personalIncomeTaxSale1",

  "Tỷ lệ Sale 2": "rateSale2",
  "Mã Sale 2": "codeSale2",
  "Họ tên sale bán trực tiếp 2": "nameSale2",
  "Thưởng nóng Sale 2": "bonusSale2",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 2":
    "accountingFromPreviousPeriodOrAdvanceSale2",
  "Thuế TNCN Sale 2": "personalIncomeTaxSale2",

  "Tỷ lệ GDKĐH": "rateGDKDH",
  "Mã GDKĐH": "codeGDKDH",
  "Họ và tên GDKĐH": "nameGDKDH",
  "Thưởng nóng GDKĐH": "bonusGDKDH",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐH":
    "accountingFromPreviousPeriodOrAdvanceGDKDH",
  "Thuế TNCN GDKĐH": "personalIncomeTaxGDKDH",

  "Tỷ lệ GDKĐT": "rateGDKDT",
  "Mã GDKĐT": "codeGDKDT",
  "Họ và tên GDKĐT": "nameGDKDT",
  "Thưởng nóng GDKĐT": "bonusGDKDT",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐT":
    "accountingFromPreviousPeriodOrAdvanceGDKDT",
  "Thuế TNCN GDKĐT": "personalIncomeTaxGDKDT",

  "Tỷ lệ GDKCL": "rateGDKCL",
  "Mã GDKCL": "codeGDKCL",
  "Họ và tên GDKCL": "nameGDKCL",
  "Thưởng nóng GDKCL": "bonusGDKCL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKCL":
    "accountingFromPreviousPeriodOrAdvanceGDKCL",
  "Thuế TNCN GDKCL": "personalIncomeTaxGDKCL",

  "Tỷ lệ GDVĐH": "rateGDVDH",
  "Mã GDVĐH": "codeGDVDH",
  "Họ và tên GDVĐH": "nameGDVDH",
  "Thưởng nóng GDVĐH": "bonusGDVDH",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐH":
    "accountingFromPreviousPeriodOrAdvanceGDVDH",
  "Thuế TNCN GDVĐH": "personalIncomeTaxGDVDH",

  "Tỷ lệ GDVĐT": "rateGDVDT",
  "Mã GDVĐT": "codeGDVDT",
  "Họ và tên GDVĐT": "nameGDVDT",
  "Thưởng nóng GDVĐT": "bonusGDVDT",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐT":
    "accountingFromPreviousPeriodOrAdvanceGDVDT",
  "Thuế TNCN GDVĐT": "personalIncomeTaxGDVDT",

  "Tỷ lệ GĐVCL": "rateGDVCL",
  "Mã GĐVCL": "codeGDVCL",
  "Thưởng nóng GĐVCL": "bonusGDVCL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GĐVCL":
    "accountingFromPreviousPeriodOrAdvanceGDVCL",
  "Thuế TNCN GĐVCL": "personalIncomeTaxGDVCL",
  "Họ và tên GĐVCL": "nameGDVCL",

  "Tỷ lệ GTĐL": "rateGTDL",
  "Mã GTĐL": "codeGTDL",
  "Họ và tên GTĐL": "nameGTDL",
  "Thưởng nóng GTĐL": "bonusGTDL",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GTĐL":
    "accountingFromPreviousPeriodOrAdvanceGTDL",
  "Thuế TNCN GTĐL": "personalIncomeTaxGTDL",

  "Tỷ lệ TGĐ": "rateTGD",
  "Mã TGĐ": "codeTGD",
  "Họ và tên TGĐ": "nameTGD",
  "Thưởng nóng TGĐ": "bonusTGD",
  "KT do đã ĐK kì trước/Đã tạm ứng/KT khác TGĐ":
    "accountingFromPreviousPeriodOrAdvanceTGD",
  "Thuế TNCN TGĐ": "personalIncomeTaxTGD",

  "Tháng đối chiếu": "monthYear",
};

export default function ServiceFeeManagement() {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenEstimate,
    onOpen: onOpenEstimate,
    onClose: onCloseEstimate,
    onToggle: onToggleEstimate,
  } = useDisclosure();
  const [paramExport, setParamExport] = useState(null);
  const { refetch, isRefetching } = useLocking();
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisibleCalculator, setPopupVisibleCalculator] = useState(false);
  const navigate = useNavigate();

  const handleExportSample = () => {
    const columnMapping = {
      monthYear: "Tháng đối chiếu",
      matchingDate: "Ngày đối chiếu",
      project: "Dự án",
      transactionDate: "Ngày KH chuyển tiền/Ngày cọc",
      kRate: "Hệ số dự án (K)",
      fundApartment: "Quỹ căn",
      codeApartment: "Mã lô",
      ttda: "TTDA",
      pricePdv: "Giá tính PDV",
      totalStandardWorking: "NCC",
      rateTransaction: "Tỷ lệ GD",
      rateTNMSH: "Tỉ lệ TN MSH (Đi kèm K) (%)",
      rateTN: "Tỉ lệ TN sàn (%)",
      rateCVKD: "Tỷ lệ PDV CVKD",
      rateCVKDElite: "Tỷ lệ PDV CVKD Elite",
      rateSale1: "Tỷ lệ Sale 1",
      codeSale1: "Mã Sale 1",
      nameSale1: "Họ tên sale bán trực tiếp 1",
      jobTitleSales1: "Chức vụ Sale 1",
      ncttSale1: "NCTT Sale 1",
      pointSale1: "Điểm ĐG Sale 1",
      bonusSale1: "Thưởng nóng Sale 1",
      priceTNMSHSale1: "Số tiền TN MSH (đi kèm K) Sale 1",
      priceTNSale1: "Số tiền TN Sàn Sale 1",
      priceCVKDSale1: "Số tiền PDV CVKD Sale 1",
      priceCVKDEliteSale1: "Số tiền PDV CVKD Elite Sale 1",
      certificateOrDepositSale1: "Chứng chỉ/ ký quỹ của Sale 1",
      accountingFromPreviousPeriodOrAdvanceSale1:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 1",
      rateSale2: "Tỷ lệ Sale 2",
      codeSale2: "Mã Sale 2",
      nameSale2: "Họ tên sale bán trực tiếp 2",
      jobTitleSales2: "Chức vụ Sale 2",
      ncttSale2: "NCTT Sale 2",
      pointSale2: "Điểm ĐG Sale 2",
      bonusSale2: "Thưởng nóng Sale 2",
      priceTNMSHSale2: "Số tiền TN MSH (đi kèm K) Sale 2",
      priceTNSale2: "Số tiền TN Sàn Sale 2",
      priceCVKDSale2: "Số tiền PDV CVKD Sale 2",
      priceCVKDEliteSale2: "Số tiền PDV CVKD Elite Sale 2",
      certificateOrDepositSale2: "Chứng chỉ/ ký quỹ của Sale 2",
      accountingFromPreviousPeriodOrAdvanceSale2:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 2",
      totalTNSale: "Tổng TN Sale",
      totalRoseSale: "Tổng PDV Sale",
      codeGDKDH: "Mã GDKĐH",
      nameGDKDH: "Họ và tên GDKĐH",
      rateGDKDH: "Tỷ lệ PDV GDKĐH",
      ncttGDKDH: "NCTT GDKĐH",
      pointGDKDH: "Điểm ĐG GDKĐH",
      bonusGDKDH: "Thưởng nóng GDKĐH",
      priceGDKDH: "Số tiền GDKĐH",
      certificateOrDepositGDKDH: "Chứng chỉ/ ký quỹ của GDKĐH",
      accountingFromPreviousPeriodOrAdvanceGDKDH:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐH",
      codeGDKDT: "Mã GDKĐT",
      nameGDKDT: "Họ và tên GDKĐT",
      rateGDKDT: "Tỷ lệ PDV GDKĐT",
      ncttGDKDT: "NCTT GDKĐT",
      pointGDKDT: "Điểm ĐG GDKĐT",
      bonusGDKDT: "Thưởng nóng GDKĐT",
      priceGDKDT: "Số tiền GDKĐT",
      certificateOrDepositGDKDT: "Chứng chỉ/ ký quỹ của GDKĐT",
      accountingFromPreviousPeriodOrAdvanceGDKDT:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐT",
      codeGDKCL: "Mã GDKCL",
      nameGDKCL: "Họ và tên GDKCL",
      rateGDKCL: "Tỷ lệ PDV GDKCL",
      ncttGDKCL: "NCTT GDKCL",
      pointGDKCL: "Điểm ĐG GDKCL",
      bonusGDKCL: "Thưởng nóng GDKCL",
      priceGDKCL: "Số tiền GDKCL",
      certificateOrDepositGDKCL: "Chứng chỉ/ ký quỹ của GDKCL",
      accountingFromPreviousPeriodOrAdvanceGDKCL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKCL",
      rateGDK: "Tỷ lệ PDV GĐK",
      priceGDK: "Số tiền GĐK",
      codeGDVDH: "Mã GDVĐH",
      nameGDVDH: "Họ và tên GDVĐH",
      rateGDVDH: "Tỷ lệ PDV GDVĐH",
      ncttGDVDH: "NCTT GDVĐH",
      pointGDVDH: "Điểm ĐG GDVĐH",
      bonusGDVDH: "Thưởng nóng GDVĐH",
      priceGDVDH: "Số tiền GDVĐH",
      certificateOrDepositGDVDH: "Chứng chỉ/ ký quỹ của GDVĐH",
      accountingFromPreviousPeriodOrAdvanceGDVDH:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐH",
      codeGDVDT: "Mã GDVĐT",
      nameGDVDT: "Họ và tên GDVĐT",
      rateGDVDT: "Tỷ lệ PDV GDVĐT",
      ncttGDVDT: "NCTT GDVĐT",
      pointGDVDT: "Điểm ĐG GDVĐT",
      bonusGDVDT: "Thưởng nóng GDVĐT",
      priceGDVDT: "Số tiền GDVĐT",
      certificateOrDepositGDVDT: "Chứng chỉ/ ký quỹ của GDVĐT",
      accountingFromPreviousPeriodOrAdvanceGDVDT:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐT",
      codeGDVCL: "Mã GĐVCL",
      nameGDVCL: "Họ và tên GĐVCL",
      rateGDVCL: "Tỷ lệ PDV GĐVCL",
      ncttGDVCL: "NCTT GĐVCL",
      pointGDVCL: "Điểm ĐG GĐVCL",
      bonusGDVCL: "Thưởng nóng GĐVCL",
      priceGDVCL: "Số tiền GĐVCL",
      certificateOrDepositGDVCL: "Chứng chỉ/ ký quỹ của GĐVCL",
      accountingFromPreviousPeriodOrAdvanceGDVCL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GĐVCL",
      rateGDV: "Tỷ lệ PDV GĐV",
      priceGDV: "Số tiền GĐV",
      codeGTDL: "Mã GTĐL",
      nameGTDL: "Họ và tên GTĐL",
      rateGTDL: "Tỷ lệ PDV/Số tiền hưởng GTĐL",
      ncttGTDL: "NCTT GTĐL",
      pointGTDL: "Điểm ĐG GTĐL",
      bonusGTDL: "Thưởng nóng GTĐL",
      priceGTDL: "Số tiền GTĐL",
      certificateOrDepositGTDL: "Chứng chỉ/ ký quỹ của GTĐL",
      accountingFromPreviousPeriodOrAdvanceGTDL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GTĐL",
      codeTGD: "Mã TGĐ",
      nameTGD: "Họ và tên TGĐ",
      ncttTGD: "NCTT TGĐ",
      rateTGD: "Tỷ lệ PDV TGĐ",
      bonusTGD: "Thưởng nóng TGĐ",
      priceTGD: "Số tiền TGĐ",
      certificateOrDepositTGD: "Chứng chỉ/ ký quỹ của TGĐ",
      accountingFromPreviousPeriodOrAdvanceTGD:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác TGĐ",
      rate: "Tỷ lệ PDV",
      price: "Số tiền",
    };

    const data = [
      {
        matchingDate: "21/07/2025",
        project: "Lumi 1+2",
        transactionDate: "07/07/2024",
        kRate: 0.8,
        fundApartment: "Bán chéo Cityhome cơ chế 85/15",
        codeApartment: "P1.08.12",
        ttda: 50,
        pricePdv: 8632899250,
        totalStandardWorking: 25,
        rateTransaction: 85,
        rateTNMSH: 1,
        rateTN: 1,
        rateCVKD: 1.5,
        rateCVKDElite: 0.2,
        rateSale1: 100,
        codeSale1: "CTV000618",
        nameSale1: "Trần Huyền Mai",
        jobTitleSales1: "CVKD Elite",
        ncttSale1: 25,
        pointSale1: 100,
        bonusSale1: 100000,
        priceTNMSHSale1: 36689822,
        priceTNSale1: 36689822,
        priceCVKDSale1: 44027786,
        priceCVKDEliteSale1: 5870371,
        certificateOrDepositSale1: "",
        accountingFromPreviousPeriodOrAdvanceSale1: 50000,
        rateSale2: "",
        codeSale2: "",
        nameSale2: "",
        jobTitleSales2: "",
        ncttSale2: "",
        pointSale2: "",
        bonusSale2: 100000,
        priceTNMSHSale2: "",
        priceTNSale2: "",
        priceCVKDSale2: "",
        priceCVKDEliteSale2: "",
        certificateOrDepositSale2: "",
        accountingFromPreviousPeriodOrAdvanceSale2: 50000,
        totalTNSale: 36689822,
        totalRoseSale: 49898158,
        codeGDKDH: "CTV000638",
        nameGDKDH: "Nguyễn Hải Anh",
        rateGDKDH: 0.085,
        ncttGDKDH: 25,
        pointGDKDH: 100,
        bonusGDKDH: 100000,
        priceGDKDH: 2935186,
        certificateOrDepositGDKDH: "",
        accountingFromPreviousPeriodOrAdvanceGDKDH: 50000,
        codeGDKDT: "CTV001193",
        nameGDKDT: "Trần Hoàng Long",
        rateGDKDT: 0.17,
        ncttGDKDT: 25,
        pointGDKDT: 100,
        bonusGDKDT: 100000,
        priceGDKDT: 5870371,
        certificateOrDepositGDKDT: "",
        accountingFromPreviousPeriodOrAdvanceGDKDT: 50000,
        codeGDKCL: "CTV001194",
        nameGDKCL: "Nguyễn Đức Mậu",
        rateGDKCL: 0.17,
        ncttGDKCL: 25,
        pointGDKCL: 100,
        bonusGDKCL: 100000,
        priceGDKCL: 5870371,
        certificateOrDepositGDKCL: "",
        accountingFromPreviousPeriodOrAdvanceGDKCL: 50000,
        rateGDK: 0.4,
        priceGDK: 14675929,
        codeGDVDH: "CTV001257",
        nameGDVDH: "Nguyễn Duy Cường",
        rateGDVDH: 0.05,
        ncttGDVDH: 25,
        pointGDVDH: 100,
        bonusGDVDH: 100000,
        priceGDVDH: 1761111,
        certificateOrDepositGDVDH: "",
        accountingFromPreviousPeriodOrAdvanceGDVDH: 50000,
        codeGDVDT: "CTV001257",
        nameGDVDT: "Nguyễn Duy Cường",
        rateGDVDT: 0.1,
        ncttGDVDT: 25,
        pointGDVDT: 100,
        bonusGDVDT: 100000,
        priceGDVDT: 3522223,
        certificateOrDepositGDVDT: "",
        accountingFromPreviousPeriodOrAdvanceGDVDT: 50000,
        codeGDVCL: "CTV001191",
        nameGDVCL: "Đinh Đức Thành",
        rateGDVCL: 0.1,
        ncttGDVCL: 25,
        pointGDVCL: 100,
        bonusGDVCL: 100000,
        priceGDVCL: 3522223,
        certificateOrDepositGDVCL: "",
        accountingFromPreviousPeriodOrAdvanceGDVCL: 50000,
        rateGDV: 0.3,
        priceGDV: 8805557,
        codeGTDL: "",
        nameGTDL: "",
        rateGTDL: 0,
        ncttGTDL: "",
        pointGTDL: 0,
        bonusGTDL: 100000,
        priceGTDL: "",
        certificateOrDepositGTDL: "",
        accountingFromPreviousPeriodOrAdvanceGTDL: 50000,
        codeTGD: "CT01-15",
        nameTGD: "Nguyễn Xuân Lộc",
        ncttTGD: 25,
        rateTGD: 0.17,
        bonusTGD: 100000,
        priceTGD: 5870371,
        certificateOrDepositTGD: "",
        accountingFromPreviousPeriodOrAdvanceTGD: 50000,
        rate: 3.55,
        price: 115939837,
        monthYear: "07/2025",
      },
      {
        matchingDate: "21/07/2025",
        project: "Lumi 1+2",
        transactionDate: "07/07/2024",
        kRate: 0.8,
        fundApartment: "Bán chéo Cityhome cơ chế 85/15",
        codeApartment: "P1.08.12",
        ttda: 50,
        pricePdv: 8632899250,
        totalStandardWorking: 25,
        rateTransaction: 85,
        rateTNMSH: 1,
        rateTN: 1,
        rateCVKD: 1.5,
        rateCVKDElite: 0.2,
        rateSale1: 100,
        codeSale1: "CTV000618",
        nameSale1: "Trần Huyền Mai",
        jobTitleSales1: "CVKD Elite",
        ncttSale1: 25,
        pointSale1: 100,
        bonusSale1: 100000,
        priceTNMSHSale1: 36689822,
        priceTNSale1: 36689822,
        priceCVKDSale1: 44027786,
        priceCVKDEliteSale1: 5870371,
        certificateOrDepositSale1: "",
        accountingFromPreviousPeriodOrAdvanceSale1: 50000,
        rateSale2: "",
        codeSale2: "",
        nameSale2: "",
        jobTitleSales2: "",
        ncttSale2: "",
        pointSale2: "",
        bonusSale2: 100000,
        priceTNMSHSale2: "",
        priceTNSale2: "",
        priceCVKDSale2: "",
        priceCVKDEliteSale2: "",
        certificateOrDepositSale2: "",
        accountingFromPreviousPeriodOrAdvanceSale2: 50000,
        totalTNSale: 36689822,
        totalRoseSale: 49898158,
        codeGDKDH: "CTV000638",
        nameGDKDH: "Nguyễn Hải Anh",
        rateGDKDH: 0.085,
        ncttGDKDH: 25,
        pointGDKDH: 100,
        bonusGDKDH: 100000,
        priceGDKDH: 2935186,
        certificateOrDepositGDKDH: "",
        accountingFromPreviousPeriodOrAdvanceGDKDH: 50000,
        codeGDKDT: "CTV001193",
        nameGDKDT: "Trần Hoàng Long",
        rateGDKDT: 0.17,
        ncttGDKDT: 25,
        pointGDKDT: 100,
        bonusGDKDT: 100000,
        priceGDKDT: 5870371,
        certificateOrDepositGDKDT: "",
        accountingFromPreviousPeriodOrAdvanceGDKDT: 50000,
        codeGDKCL: "CTV001194",
        nameGDKCL: "Nguyễn Đức Mậu",
        rateGDKCL: 0.17,
        ncttGDKCL: 25,
        pointGDKCL: 100,
        bonusGDKCL: 100000,
        priceGDKCL: 5870371,
        certificateOrDepositGDKCL: "",
        accountingFromPreviousPeriodOrAdvanceGDKCL: 50000,
        rateGDK: 0.4,
        priceGDK: 14675929,
        codeGDVDH: "CTV001257",
        nameGDVDH: "Nguyễn Duy Cường",
        rateGDVDH: 0.05,
        ncttGDVDH: 25,
        pointGDVDH: 100,
        bonusGDVDH: 100000,
        priceGDVDH: 1761111,
        certificateOrDepositGDVDH: "",
        accountingFromPreviousPeriodOrAdvanceGDVDH: 50000,
        codeGDVDT: "CTV001257",
        nameGDVDT: "Nguyễn Duy Cường",
        rateGDVDT: 0.1,
        ncttGDVDT: 25,
        pointGDVDT: 100,
        bonusGDVDT: 100000,
        priceGDVDT: 3522223,
        certificateOrDepositGDVDT: "",
        accountingFromPreviousPeriodOrAdvanceGDVDT: 50000,
        codeGDVCL: "CTV001191",
        nameGDVCL: "Đinh Đức Thành",
        rateGDVCL: 0.1,
        ncttGDVCL: 25,
        pointGDVCL: 100,
        bonusGDVCL: 100000,
        priceGDVCL: 3522223,
        certificateOrDepositGDVCL: "",
        accountingFromPreviousPeriodOrAdvanceGDVCL: 50000,
        rateGDV: 0.3,
        priceGDV: 8805557,
        codeGTDL: "",
        nameGTDL: "",
        rateGTDL: 0,
        ncttGTDL: "",
        pointGTDL: 0,
        bonusGTDL: 100000,
        priceGTDL: "",
        certificateOrDepositGTDL: "",
        accountingFromPreviousPeriodOrAdvanceGTDL: 50000,
        codeTGD: "CT01-15",
        nameTGD: "Nguyễn Xuân Lộc",
        ncttTGD: 25,
        rateTGD: 0.17,
        bonusTGD: 100000,
        priceTGD: 5870371,
        certificateOrDepositTGD: "",
        accountingFromPreviousPeriodOrAdvanceTGD: 50000,
        rate: 3.55,
        price: 115939837,
        monthYear: "07/2025",
      },
    ];
    // try {
    //   exportFile(data, columnMapping, "mau_import_phi_dich_vu.xlsx");
    //   toast.success("Download file thành công");
    // } catch (error) {
    //   toast.error("Export lỗi");
    //   console.log(error);
    // }
    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "mau_import_phi_dich_vu.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  const handleExportSampleCalculator = () => {
    const columnMapping = {
      codeApartment: "Mã lô",
      ttda: "TTDA",
      rateTNSan: "Tỉ lệ thưởng nóng sàn",
      priceTNSan: "Số tiền TN sàn",
      transactionRate: "Tỉ lệ nhận về",
      rateSale1: "Tỷ lệ Sale 1",
      codeSale1: "Mã Sale 1",
      nameSale1: "Họ tên sale bán trực tiếp 1",
      bonusSale1: "Thưởng nóng Sale 1",
      accountingFromPreviousPeriodOrAdvanceSale1:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 1",
      personalIncomeTaxSale1: "Thuế TNCN Sale 1",
      rateSale2: "Tỷ lệ Sale 2",
      codeSale2: "Mã Sale 2",
      bonusSale2: "Thưởng nóng Sale 2",
      accountingFromPreviousPeriodOrAdvanceSale2:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 2",
      personalIncomeTaxSale2: "Thuế TNCN Sale 2",
      nameSale2: "Họ tên sale bán trực tiếp 2",
      rateGDKDH: "Tỷ lệ GDKĐH",
      codeGDKDH: "Mã GDKĐH",
      nameGDKDH: "Họ và tên GDKĐH",
      bonusGDKDH: "Thưởng nóng GDKĐH",
      accountingFromPreviousPeriodOrAdvanceGDKDH:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐH",
      personalIncomeTaxGDKDH: "Thuế TNCN GDKĐH",
      rateGDKDT: "Tỷ lệ GDKĐT",
      codeGDKDT: "Mã GDKĐT",
      nameGDKDT: "Họ và tên GDKĐT",
      bonusGDKDT: "Thưởng nóng GDKĐT",
      accountingFromPreviousPeriodOrAdvanceGDKDT:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐT",
      personalIncomeTaxGDKDT: "Thuế TNCN GDKĐT",
      rateGDKCL: "Tỷ lệ GDKCL",
      codeGDKCL: "Mã GDKCL",
      nameGDKCL: "Họ và tên GDKCL",
      bonusGDKCL: "Thưởng nóng GDKCL",
      accountingFromPreviousPeriodOrAdvanceGDKCL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKCL",
      personalIncomeTaxGDKCL: "Thuế TNCN GDKCL",
      rateGDVDH: "Tỷ lệ GDVĐH",
      codeGDVDH: "Mã GDVĐH",
      nameGDVDH: "Họ và tên GDVĐH",
      bonusGDVDH: "Thưởng nóng GDVĐH",
      accountingFromPreviousPeriodOrAdvanceGDVDH:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐH",
      personalIncomeTaxGDVDH: "Thuế TNCN GDVĐH",
      rateGDVDT: "Tỷ lệ GDVĐT",
      codeGDVDT: "Mã GDVĐT",
      nameGDVDT: "Họ và tên GDVĐT",
      bonusGDVDT: "Thưởng nóng GDVĐT",
      accountingFromPreviousPeriodOrAdvanceGDVDT:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐT",
      personalIncomeTaxGDVDT: "Thuế TNCN GDVĐT",
      rateGDVCL: "Tỷ lệ GĐVCL",
      codeGDVCL: "Mã GĐVCL",
      nameGDVCL: "Họ và tên GĐVCL",
      bonusGDVCL: "Thưởng nóng GĐVCL",
      accountingFromPreviousPeriodOrAdvanceGDVCL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GĐVCL",
      personalIncomeTaxGDVCL: "Thuế TNCN GĐVCL",
      rateGTDL: "Tỷ lệ GTĐL",
      codeGTDL: "Mã GTĐL",
      nameGTDL: "Họ và tên GTĐL",
      bonusGTDL: "Thưởng nóng GTĐL",
      accountingFromPreviousPeriodOrAdvanceGTDL:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GTĐL",
      personalIncomeTaxGTDL: "Thuế TNCN GTĐL",
      rateTGD: "Tỷ lệ TGĐ",
      codeTGD: "Mã TGĐ",
      nameTGD: "Họ và tên TGĐ",
      bonusTGD: "Thưởng nóng TGĐ",
      accountingFromPreviousPeriodOrAdvanceTGD:
        "KT do đã ĐK kì trước/Đã tạm ứng/KT khác TGĐ",
      personalIncomeTaxTGD: "Thuế TNCN TGĐ",

      monthYear: "Tháng đối chiếu",
    };

    const data = [
      {
        codeApartment: "P1.08.12",
        ttda: 50,
        rateTNSan: 0,
        priceTNSan: 0,
        transactionRate: 100,
        rateSale1: 100,
        codeSale1: "CTV000618",
        nameSale1: "",
        bonusSale1: 100000,
        accountingFromPreviousPeriodOrAdvanceSale1: 100000,
        personalIncomeTaxSale1: "",
        rateSale2: "",
        codeSale2: "",
        nameSale2: "",
        bonusSale2: 100000,
        accountingFromPreviousPeriodOrAdvanceSale2: 100000,
        personalIncomeTaxSale2: "",
        rateGDKDH: "",
        codeGDKDH: "CTV000638",
        nameGDKDH: "Nguyễn Hải Anh",
        bonusGDKDH: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKDH: 100000,
        personalIncomeTaxGDKDH: "",
        rateGDKDT: "",
        codeGDKDT: "CTV001193",
        nameGDKDT: "Trần Hoàng Long",
        bonusGDKDT: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKDT: 100000,
        personalIncomeTaxGDKDT: "",
        rateGDKCL: "",
        codeGDKCL: "CTV001194",
        nameGDKCL: "Nguyễn Đức Mậu",
        bonusGDKCL: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKCL: 100000,
        personalIncomeTaxGDKCL: "",
        rateGDVDH: "",
        codeGDVDH: "CTV001257",
        nameGDVDH: "Nguyễn Duy Cường",
        bonusGDVDH: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVDH: 100000,
        personalIncomeTaxGDVDH: "",
        rateGDVDT: "",
        codeGDVDT: "CTV001257",
        nameGDVDT: "Nguyễn Duy Cường",
        bonusGDVDT: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVDT: 100000,
        personalIncomeTaxGDVDT: "",
        rateGDVCL: "",
        codeGDVCL: "CTV001191",
        nameGDVCL: "Đinh Đức Thành",
        bonusGDVCL: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVCL: 100000,
        personalIncomeTaxGDVCL: "",
        rateGTDL: "",
        codeGTDL: "",
        nameGTDL: "",
        bonusGTDL: 100000,
        accountingFromPreviousPeriodOrAdvanceGTDL: 100000,
        personalIncomeTaxGTDL: "",
        rateTGD: "",
        codeTGD: "CT01-15",
        nameTGD: "Nguyễn Xuân Lộc",
        bonusTGD: 100000,
        accountingFromPreviousPeriodOrAdvanceTGD: 100000,
        personalIncomeTaxTGD: "",
        monthYear: "07/2025",
      },
      {
        codeApartment: "P1.08.12",
        ttda: 50,
        rateTNSan: 0,
        priceTNSan: 0,
        transactionRate: 100,
        rateSale1: 100,
        codeSale1: "CTV000618",
        nameSale1: "",
        bonusSale1: 100000,
        accountingFromPreviousPeriodOrAdvanceSale1: 100000,
        personalIncomeTaxSale1: "",
        rateSale2: "",
        codeSale2: "",
        nameSale2: "",
        bonusSale2: 100000,
        accountingFromPreviousPeriodOrAdvanceSale2: 100000,
        personalIncomeTaxSale2: "",
        rateGDKDH: "",
        codeGDKDH: "CTV000638",
        nameGDKDH: "Nguyễn Hải Anh",
        bonusGDKDH: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKDH: 100000,
        personalIncomeTaxGDKDH: "",
        rateGDKDT: "",
        codeGDKDT: "CTV001193",
        nameGDKDT: "Trần Hoàng Long",
        bonusGDKDT: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKDT: 100000,
        personalIncomeTaxGDKDT: "",
        rateGDKCL: "",
        codeGDKCL: "CTV001194",
        nameGDKCL: "Nguyễn Đức Mậu",
        bonusGDKCL: 100000,
        accountingFromPreviousPeriodOrAdvanceGDKCL: 100000,
        personalIncomeTaxGDKCL: "",
        rateGDVDH: "",
        codeGDVDH: "CTV001257",
        nameGDVDH: "Nguyễn Duy Cường",
        bonusGDVDH: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVDH: 100000,
        personalIncomeTaxGDVDH: "",
        rateGDVDT: "",
        codeGDVDT: "CTV001257",
        nameGDVDT: "Nguyễn Duy Cường",
        bonusGDVDT: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVDT: 100000,
        personalIncomeTaxGDVDT: "",
        rateGDVCL: "",
        codeGDVCL: "CTV001191",
        nameGDVCL: "Đinh Đức Thành",
        bonusGDVCL: 100000,
        accountingFromPreviousPeriodOrAdvanceGDVCL: 100000,
        personalIncomeTaxGDVCL: "",
        rateGTDL: "",
        codeGTDL: "",
        nameGTDL: "",
        bonusGTDL: 100000,
        accountingFromPreviousPeriodOrAdvanceGTDL: 100000,
        personalIncomeTaxGTDL: "",
        rateTGD: "",
        codeTGD: "CT01-15",
        nameTGD: "Nguyễn Xuân Lộc",
        bonusTGD: 100000,
        accountingFromPreviousPeriodOrAdvanceTGD: 100000,
        personalIncomeTaxTGD: "",
        monthYear: "04/2026",
      },
    ];
    // try {
    //   exportFile(data, columnMapping, "mau_import_tinh_toan_phi_dich_vu.xlsx");
    //   toast.success("Download file thành công");
    // } catch (error) {
    //   toast.error("Export lỗi");
    //   console.log(error);
    // }

    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "mau_import_tinh_toan_phi_dich_vu.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  const handleExport = async () => {
    const checkInColumnMapping = {
      project: "Dự án",
      transactionDate: "Ngày ký HĐMB",
      saleOpeningEvent: "Đợt mở bán",
      product: "Mã lô",
      customer: "Họ và tên khách hàng",
      totalValue: "Giá niêm yết",
      price: "Giá trị giao dịch",
      priceForCommission: "Giá tính PDV",
      standardWorkingDaysInMonth: "Ngày công chuẩn",
      transactionRate: "Tỷ lệ GD",
      incomeRate: "Tỷ lệ TN",
      platformIncomeRate: "Tỷ lệ TN Sàn",
      commissionRate1: "Tỷ lệ Sale 1",
      code1: "Mã Sale 1",
      name1: "Họ tên sale bán trực tiếp 1",
      // jobPosition1: "Chức vụ",
      workingDays1: "Ngày công sale 1",
      codeCTV1: "Mã CTV sales 1",
      codeGDK1: "Mã giám đốc khối sale1",
      nameGDK1: "Tên giám đốc khối sale 1",
      workingDaysGDK1: "Ngày công giám đốc khối sale 1",
      codeGDV1: "Mã giám đốc vùng sale 1",
      nameGDV1: "Tên giám đốc vùng sale 1",
      workingDaysGDV1: "Ngày công giám đốc vùng sale 1",
      commissionRate2: "Tỷ lệ Sale 2",
      code2: "Mã Sale 2",
      name2: "Họ tên sale bán trực tiếp 2",
      // jobPosition2: "Chức vụ",
      workingDays2: "Ngày công sale 2",
      codeCTV2: "Mã CTV sales 2 ",
      codeGDK2: "Mã Giám đốc khối sale 2",
      nameGDK2: "Tên giám đốc khối sale 2",
      workingDaysGDK2: "Ngày công giám đốc khối sale 2",
      codeGDV2: "Mã giám đốc vùng sale 2",
      nameGDV2: "Tên giám đốc vùng sale 2",
      workingDaysGDV2: "Ngày công giám đốc vùng sale 2",
    };

    // const data = await commissionAnalystCall.exportCommissionAnalyst(
    //   paramExport
    // );
    // if (data) {
    //   exportFile(data, checkInColumnMapping, "bang_thong_so_giao_dich.xlsx");
    //   toast.success("Xuất file thành công");
    // } else {
    //   toast.error("Không có dữ liệu");
    // }
    await exportExcelFromApi({
      fetcher: () => commissionAnalystCall.exportCommissionAnalyst(paramExport),
      mapping: checkInColumnMapping,
      filename: "bang_thong_so_giao_dich.xlsx",
      toastMessages: {
        loading: "Đang tải dữ liệu & xuất file...",
        success: "Xuất file thành công",
        noData: "Không có dữ liệu",
        error: "Xuất file thất bại",
      },
    });
  };

  const deleteCommission = () => {
    navigate("/delete-commission");
  };

  const handleCheckCommission = () => {
    navigate("/check-commission");
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex flexDirection={"column"} gap={4}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý phí dịch vụ
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"} wrap={"wrap"} w={"100%"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={deleteCommission}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xóa đợt tính phí dịch vụ
            </Text>
          </Button>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--color-button)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleCheckCommission}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Kiểm tra PDV
            </Text>
          </Button>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpenEstimate}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất chi tiết phí dịch vụ tạm tính
            </Text>
          </Button>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất chi tiết phí dịch vụ
            </Text>
          </Button>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất thông tin giao dịch
            </Text>
          </Button>
          <Button
            w={"240px"}
            h={"44px"}
            as={Button}
            backgroundImage="var(--color-button)"
            _hover={{
              filter: "brightness(96%)",
            }}
            onClick={() => setPopupVisibleCalculator(true)}
            gap={"16px"}
            p={"10px 16px"}
          >
            <Flex alignItems={"center"} gap={"8px"}>
              <Image src={IconFile} />
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={600}
                color="var(--color-main)"
              >
                Tính toán phí dịch vụ
              </Text>
            </Flex>
          </Button>
          <Button
            w={"240px"}
            h={"44px"}
            as={Button}
            backgroundImage="var(--color-button)"
            _hover={{
              filter: "brightness(96%)",
            }}
            onClick={() => setPopupVisible(true)}
            gap={"16px"}
            p={"10px 16px"}
          >
            <Flex alignItems={"center"} gap={"8px"}>
              <Image src={IconFile} />
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={600}
                color="var(--color-main)"
              >
                Import tính phí dịch vụ
              </Text>
            </Flex>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableLocking
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>

      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm tính phí dịch vụ"
          inputAdd="Nhập danh sách tính phí dịch vụ"
          type={"commissionAnalyst"}
          isTypePrice={true}
          isKRate={true}
          requiredCheck={true}
        />
      )}
      {popupVisibleCalculator && (
        <PopupImport
          isOpen={popupVisibleCalculator}
          onClose={() => setPopupVisibleCalculator(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverseCalculator}
          handleExport={handleExportSampleCalculator}
          titleAdd="Thêm tính toán phí dịch vụ"
          inputAdd="Nhập danh sách toán tính phí dịch vụ"
          type={"bulkCalculator"}
          isTypePrice={true}
          isKRate={true}
          requiredCheck={true}
        />
      )}
      <PopupExport isOpen={isOpen} onClose={onClose} />
      <PopupExportEstimate isOpen={isOpenEstimate} onClose={onCloseEstimate} />
    </Box>
  );
}

const PopupExport = memo(({ isOpen, onClose }) => {
  const [apartmentId, setApartmentId] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const [saleOpeningEventId, setSaleOpeningEventId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [dateRangeCreated, setDateRangeCreated] = useState([null, null]);
  const [startDateCreated, endDateCreated] = dateRangeCreated;
  const [dateRangeCalculatorTime, setDateRangeCalculatorTime] = useState([
    null,
    null,
  ]);
  const [startCalculatorTime, endCalculatorTime] = dateRangeCalculatorTime;
  const [reconciliationMonthDate, setReconciliationMonthDate] = useState(null);

  useEffect(() => {
    if (isOpen) setReconciliationMonthDate(null);
  }, [isOpen]);

  const { constantData } = useCategories(null, null, 1, false);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project],
  );
  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee],
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments],
  );
  const setSaleOpeningEvents = useMemo(
    () => formatEntries(constantData?.saleOpeningEvent),
    [constantData?.saleOpeningEvent],
  );
  const customers = useMemo(() => {
    if (!constantData?.customer) return [];

    return Object.entries(constantData.customer).map(
      ([id, { fullName, phone, identificationNumber }]) => ({
        key: id,
        value: `${fullName}`,
        phone,
        identificationNumber,
      }),
    );
  }, [constantData?.customer]);

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea],
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock],
  );

  useEffect(() => {
    setApartmentId([]);
    setProjectId([]);
    setSaleOpeningEventId(null);
    setCustomerId(null);
    setEmployeeId(null);
    setZIndex(1);
    setDateRange([null, null]);
    setSaleBlockId(null);
    setSaleAreaId(null);
    setDateRangeCreated([null, null]);
    setDateRangeCalculatorTime([null, null]);
  }, [isOpen]);

  const columnMapping = {
    project: "Dự án",
    codeApartment: "Mã căn",
    period: "Đợt",
    transactionDate: "Ngày KH chuyển tiền/Ngày cọc",
    kRate: "Hệ số dự án (K)",
    ttda: "TTDA",
    priceForCommission: "Giá tính PDV",
    standardWorkingDaysInMonth: "NCC",
    transactionRate: "Tỉ lệ nhận về",
    incomeRate: "Tỉ lệ TN",
    salesCommissionRate: "Tỉ lệ PDV CVKD",
    eliteSalesCommissionRate: "Tỉ lệ PDV CVKD Elite",

    rateSale1: "Tỷ lệ Sale 1",
    codeSale1: "Mã Sale 1",
    nameSale1: "Họ tên sale bán trực tiếp 1",
    workingDaySale1: "NC Sale 1",
    bonusSale1: "Thưởng nóng Sale 1",
    priceTNSanSale1: "Số tiền TN sàn Sale 1",
    priceTNSale1: "Số tiền TN MSH Sale 1",
    priceCVKDSale1: "Số tiền PDV CVKD Sale 1",
    salesCommissionPriceSale1: "Số tiền PDV CVKD Sale 1",
    eliteSalesCommissionPriceSale1: "Số tiền PDV CVKD Elite Sale 1",

    rateSale2: "Tỷ lệ Sale 2",
    codeSale2: "Mã Sale 2",
    nameSale2: "Họ tên sale bán trực tiếp 2",
    workingDaySale2: "NC Sale 2",
    bonusSale2: "Thưởng nóng Sale 2",
    priceTNSanSale2: "Số tiền TN sàn Sale 2",
    priceTNSale2: "Số tiền TN MSH Sale 2",
    priceCVKDSale2: "Số tiền PDV CVKD Sale 2",
    salesCommissionPriceSale2: "Số tiền PDV CVKD Sale 2",
    eliteSalesCommissionPriceSale2: "Số tiền PDV CVKD Elite Sale 2",

    totalRelativeParticipantIncomePriceOwn: "Tổng TN Sale",
    totalRelativeParticipantCommissionPriceOwn: "Tổng PDV Sale",

    rateGDKDH: "Tỷ lệ GDKĐH",
    codeGDKDH: "Mã GDKĐH",
    nameGDKDH: "Họ và tên GDKĐH",
    workingDayGDKDH: "NC GDKDH",
    bonusGDKDH: "Thưởng nóng GDKĐH",
    incomePriceGDKDH: "Số tiền TN GDKDH",

    rateGDKDT: "Tỷ lệ GDKĐT",
    codeGDKDT: "Mã GDKĐT",
    nameGDKDT: "Họ và tên GDKĐT",
    workingDayGDKDT: "NC GDKĐT",
    bonusGDKDT: "Thưởng nóng GDKĐT",
    incomePriceGDKDT: "Số tiền TN GDKĐT",

    rateGDKCL: "Tỷ lệ GDKCL",
    codeGDKCL: "Mã GDKCL",
    nameGDKCL: "Họ và tên GDKCL",
    bonusGDKCL: "Thưởng nóng GDKCL",
    workingDayGDKCL: "NC GDKCL",
    incomePriceGDKCL: "Số tiền TN GDKCL",

    totalSaleBlockManagerCommissionRate: "Tỷ lệ PDV GĐK",
    totalSaleBlockManagerCommissionPrice: "Số tiền GĐK",

    rateGDVDH: "Tỷ lệ GDVĐH",
    codeGDVDH: "Mã GDVĐH",
    nameGDVDH: "Họ và tên GDVĐH",
    bonusGDVDH: "Thưởng nóng GDVĐH",
    workingDayGDVDH: "NC GDVĐH",
    incomePriceGDVDH: "Số tiền TN GDVĐH",

    rateGDVDT: "Tỷ lệ GDVĐT",
    codeGDVDT: "Mã GDVĐT",
    nameGDVDT: "Họ và tên GDVĐT",
    workingDayGDVDT: "NC GDVĐT",
    bonusGDVDT: "Thưởng nóng GDVĐT",
    incomePriceGDVDT: "Số tiền TN GDVĐT",

    rateGDVCL: "Tỷ lệ GĐVCL",
    codeGDVCL: "Mã GĐVCL",
    nameGDVCL: "Họ và tên GĐVCL",
    workingDayGDVCL: "NC GĐVCL",
    bonusGDVCL: "Thưởng nóng GĐVCL",
    incomePriceGDVCL: "Số tiền TN GĐVCL",

    totalSaleAreaManagerCommissionRate: "Tỷ lệ PDV GĐV",
    totalSaleAreaManagerCommissionPrice: "Số tiền GĐV",

    rateGTDL: "Tỷ lệ GTDL",
    codeGTDL: "Mã GTĐL",
    nameGTDL: "Họ và tên GTĐL",
    workingDayGTDL: "NC GTDL",
    bonusGTDL: "Thưởng nóng GTĐL",
    incomePriceGTDL: "Số tiền TN GTDL",

    rateTGD: "Tỷ lệ TGD",
    codeTGD: "Mã TGĐ",
    nameTGD: "Họ và tên TGĐ",
    workingDayTGD: "NC TGD",
    bonusTGD: "Thưởng nóng TGĐ",
    incomePriceTGD: "Số tiền TN TGD",

    totalAllCommissionRate: "Tổng tỷ lệ PDV",
    totalAllCommissionPrice: "Tổng số tiền PDV",
  };

  const columnMapping2 = {
    project: "Dự án",
    codeApartment: "Mã căn",
    period: "Đợt",
    codeEmployee: "Mã NV",
    fullNameEmployee: "Tên NV",
    commissionPrice: "Số tiền",
    certificateOrDeposit: "Chứng chỉ/ ký quỹ",
    accountingFromPreviousPeriodOrAdvance:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác",
    remainingRevenueAfterAccounting: "PDV còn lại sau KT",
    personalIncomeTax: "Thuế TNCN",
    bonus: "Thưởng nóng",
    remainingRevenueAfterTax: "PDV còn lại sau thuế",
  };

  const onSubmit = async () => {
    try {
      const { dataExport, dataExport2, dataExport3, uniqueSaleOpeningEvents } =
        await commissionAnalystCall.exportCalculator({
          projectId,
          bookerId: employeeId,
          apartmentId,
          saleOpeningEventId,
          customerId,
          saleAreaId,
          saleBlockId,
          startTime: startDate,
          endTime: endDate,
          startTimeCreated: startDateCreated,
          endTimeCreated: endDateCreated,
          startCalculatorTime,
          endCalculatorTime,
          reconciliationMonthDate,
        });
      if (dataExport?.length === 0) {
        toast.error("Không có dữ liệu nào!");
      } else {
        const dynamicEventColumns = uniqueSaleOpeningEvents?.reduce(
          (acc, item) => {
            acc[item?._id?.toString()] = item.name || "";
            return acc;
          },
          {},
        );

        exportFile(
          dataExport,
          { ...columnMapping, reconciliationPeriod: "Tháng đối chiếu" },
          "chi_tiet_tinh_phi_dich_vu.xlsx",
          "Chi tiết PDV",
          dataExport2,
          { ...columnMapping2, reconciliationPeriod: "Tháng đối chiếu" },
          "PDV theo căn",
          dataExport3,
          {
            codeEmployee: "Mã NV",
            fullNameEmployee: "Tên NV",
            period: "Đợt",
            ...dynamicEventColumns,
            commissionPrice: "Tổng cộng",
            certificateOrDeposit: "Chứng chỉ/ ký quỹ",
            accountingFromPreviousPeriodOrAdvance:
              "KT do đã ĐK kì trước/Đã tạm ứng/KT khác",
            remainingRevenueAfterAccounting: "PDV còn lại sau KT",
            personalIncomeTax: "Thuế TNCN",
            bonus: "Thưởng nóng",
            remainingRevenueAfterTax: "PDV còn lại sau thuế",
          },
          "Tổng PDV",
          // Cột theo đợt mở bán (tiêu đề = tên dự án) là cột tiền -> ép format.
          {
            moneyHeaders: Object.values(dynamicEventColumns || {}).filter(
              Boolean,
            ),
          },
        );
        toast.success("Xuất file thành công");
      }
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"1024px"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Xuất chi tiết phí dịch vụ
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>
        <Box padding={"24px"}>
          <Flex
            alignItems={"center"}
            gap={{ base: "16px 32px" }}
            flex={"1"}
            flexWrap={"wrap"}
            w={"100%"}
            paddingBottom={"32px"}
          >
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selected={reconciliationMonthDate}
                onChange={(date) => {
                  setReconciliationMonthDate(date);
                }}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                locale="vi"
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Tháng đối chiếu"
                className="datePickerStyle"
                popperProps={{ strategy: "fixed" }}
                portalId="datepicker-portal"
              />
              {!reconciliationMonthDate && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRange(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày đặt cọc từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startDate && !endDate && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startDateCreated}
                endDate={endDateCreated}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRangeCreated(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày tạo từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startDateCreated && !endDateCreated && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <InputGroup w={"100%"} maxW={"300px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startCalculatorTime}
                endDate={endCalculatorTime}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRangeCalculatorTime(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày tính giao dịch từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startCalculatorTime && !endCalculatorTime && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <SearchableSelectMulti
              isShowSearch={true}
              options={apartments}
              // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
              placeholder={"Chọn mã căn"}
              setValue={setApartmentId}
            />
            <SearchableSelectMulti
              isShowSearch={true}
              options={projects}
              // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
              placeholder={"Chọn dự án"}
              setValue={setProjectId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={setSaleOpeningEvents}
              initialSelectedOption={{ key: 0, value: "Chọn đợt mở bán" }}
              // placeholder={"Chọn đợt mở bán"}
              setValue={setSaleOpeningEventId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={customers}
              initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
              setValue={setCustomerId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={employees}
              initialSelectedOption={{
                key: 0,
                value: "Chọn nhân viên tạo",
              }}
              setValue={setEmployeeId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={saleBlocks}
              initialSelectedOption={{ key: 0, value: "Chọn khối" }}
              setValue={setSaleBlockId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={saleAreas}
              initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
              setValue={setSaleAreaId}
            />
          </Flex>
          <Box
            // position={"absolute"}
            w={"100%"}
            // bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
            zIndex={3}
          >
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              <Button
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-option-employee-hover)"}
                borderRadius={"8px"}
                border={"1px solid var(--color-option-employee-hover)"}
                bg={"var(--color-main)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
                onClick={onClose}
              >
                Hủy
              </Button>
              <Button
                onClick={onSubmit}
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Xuất excel
              </Button>
            </Flex>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});

const PopupExportEstimate = memo(({ isOpen, onClose }) => {
  const [apartmentId, setApartmentId] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const [saleOpeningEventId, setSaleOpeningEventId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [dateRangeCreated, setDateRangeCreated] = useState([null, null]);
  const [startDateCreated, endDateCreated] = dateRangeCreated;
  const [dateRangeCalculatorTime, setDateRangeCalculatorTime] = useState([
    null,
    null,
  ]);
  const [startCalculatorTime, endCalculatorTime] = dateRangeCalculatorTime;

  const { constantData } = useCategories(null, null, 1, false);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project],
  );
  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee],
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments],
  );
  const setSaleOpeningEvents = useMemo(
    () => formatEntries(constantData?.saleOpeningEvent),
    [constantData?.saleOpeningEvent],
  );
  const customers = useMemo(() => {
    if (!constantData?.customer) return [];

    return Object.entries(constantData.customer).map(
      ([id, { fullName, phone, identificationNumber }]) => ({
        key: id,
        value: `${fullName}`,
        phone,
        identificationNumber,
      }),
    );
  }, [constantData?.customer]);

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea],
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock],
  );

  useEffect(() => {
    setApartmentId([]);
    setProjectId([]);
    setSaleOpeningEventId(null);
    setCustomerId(null);
    setEmployeeId(null);
    setZIndex(1);
    setDateRange([null, null]);
    setSaleBlockId(null);
    setSaleAreaId(null);
    setDateRangeCreated([null, null]);
    setDateRangeCalculatorTime([null, null]);
  }, [isOpen]);

  const columnMapping = {
    project: "Dự án",
    codeApartment: "Mã căn",
    period: "Đợt",
    transactionDate: "Ngày KH chuyển tiền/Ngày cọc",
    kRate: "Hệ số dự án (K)",
    ttda: "TTDA",
    priceForCommission: "Giá tính PDV",
    standardWorkingDaysInMonth: "NCC",
    transactionRate: "Tỉ lệ nhận về",
    incomeRate: "Tỉ lệ TN",
    salesCommissionRate: "Tỉ lệ PDV CVKD",
    eliteSalesCommissionRate: "Tỉ lệ PDV CVKD Elite",

    rateSale1: "Tỷ lệ Sale 1",
    codeSale1: "Mã Sale 1",
    nameSale1: "Họ tên sale bán trực tiếp 1",
    workingDaySale1: "NC Sale 1",
    bonusSale1: "Thưởng nóng Sale 1",
    accountingFromPreviousPeriodOrAdvanceSale1:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 1",
    priceTNSale1: "Số tiền TN Sàn Sale 1",
    priceCVKDSale1: "Số tiền PDV CVKD Sale 1",
    salesCommissionPriceSale1: "Số tiền PDV CVKD Sale 1",
    eliteSalesCommissionPriceSale1: "Số tiền PDV CVKD Elite Sale 1",

    rateSale2: "Tỷ lệ Sale 2",
    codeSale2: "Mã Sale 2",
    nameSale2: "Họ tên sale bán trực tiếp 2",
    workingDaySale2: "NC Sale 2",
    bonusSale2: "Thưởng nóng Sale 2",
    accountingFromPreviousPeriodOrAdvanceSale2:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác Sale 2",
    priceTNSale2: "Số tiền TN Sàn Sale 2",
    priceCVKDSale2: "Số tiền PDV CVKD Sale 2",
    salesCommissionPriceSale2: "Số tiền PDV CVKD Sale 2",
    eliteSalesCommissionPriceSale2: "Số tiền PDV CVKD Elite Sale 2",

    totalRelativeParticipantIncomePrice: "Tổng TN Sale",
    totalRelativeParticipantCommissionPrice: "Tổng PDV Sale",

    rateGDKDH: "Tỷ lệ GDKĐH",
    codeGDKDH: "Mã GDKĐH",
    nameGDKDH: "Họ và tên GDKĐH",
    workingDayGDKDH: "NC GDKDH",
    bonusGDKDH: "Thưởng nóng GDKĐH",
    accountingFromPreviousPeriodOrAdvanceGDKDH:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐH",
    incomePriceGDKDH: "Số tiền TN GDKDH",

    rateGDKDT: "Tỷ lệ GDKĐT",
    codeGDKDT: "Mã GDKĐT",
    nameGDKDT: "Họ và tên GDKĐT",
    workingDayGDKDT: "NC GDKĐT",
    bonusGDKDT: "Thưởng nóng GDKĐT",
    accountingFromPreviousPeriodOrAdvanceGDKDT:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKĐT",
    incomePriceGDKDT: "Số tiền TN GDKĐT",

    rateGDKCL: "Tỷ lệ GDKCL",
    codeGDKCL: "Mã GDKCL",
    nameGDKCL: "Họ và tên GDKCL",
    bonusGDKCL: "Thưởng nóng GDKCL",
    workingDayGDKCL: "NC GDKCL",
    accountingFromPreviousPeriodOrAdvanceGDKCL:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDKCL",
    incomePriceGDKCL: "Số tiền TN GDKCL",

    totalSaleBlockManagerCommissionRate: "Tỷ lệ PDV GĐK",
    totalSaleBlockManagerCommissionPrice: "Số tiền GĐK",

    rateGDVDH: "Tỷ lệ GDVĐH",
    codeGDVDH: "Mã GDVĐH",
    nameGDVDH: "Họ và tên GDVĐH",
    bonusGDVDH: "Thưởng nóng GDVĐH",
    workingDayGDVDH: "NC GDVĐH",
    accountingFromPreviousPeriodOrAdvanceGDVDH:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐH",
    incomePriceGDVDH: "Số tiền TN GDVĐH",

    rateGDVDT: "Tỷ lệ GDVĐT",
    codeGDVDT: "Mã GDVĐT",
    nameGDVDT: "Họ và tên GDVĐT",
    workingDayGDVDT: "NC GDVĐT",
    bonusGDVDT: "Thưởng nóng GDVĐT",
    accountingFromPreviousPeriodOrAdvanceGDVDT:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GDVĐT",
    incomePriceGDVDT: "Số tiền TN GDVĐT",

    rateGDVCL: "Tỷ lệ GĐVCL",
    codeGDVCL: "Mã GĐVCL",
    nameGDVCL: "Họ và tên GĐVCL",
    workingDayGDVCL: "NC GĐVCL",
    bonusGDVCL: "Thưởng nóng GĐVCL",
    accountingFromPreviousPeriodOrAdvanceGDVCL:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GĐVCL",
    incomePriceGDVCL: "Số tiền TN GĐVCL",

    totalSaleAreaManagerCommissionRate: "Tỷ lệ PDV GĐV",
    totalSaleAreaManagerCommissionPrice: "Số tiền GĐV",

    rateGTDL: "Tỷ lệ GTDL",
    codeGTDL: "Mã GTĐL",
    nameGTDL: "Họ và tên GTĐL",
    workingDayGTDL: "NC GTDL",
    bonusGTDL: "Thưởng nóng GTĐL",
    accountingFromPreviousPeriodOrAdvanceGTDL:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác GTĐL",
    incomePriceGTDL: "Số tiền TN GTDL",

    rateTGD: "Tỷ lệ TGD",
    codeTGD: "Mã TGĐ",
    nameTGD: "Họ và tên TGĐ",
    workingDayTGD: "NC TGD",
    bonusTGD: "Thưởng nóng TGĐ",
    accountingFromPreviousPeriodOrAdvanceTGD:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác TGĐ",
    incomePriceTGD: "Số tiền TN TGD",

    totalAllCommissionRate: "Tổng tỷ lệ PDV",
    totalAllCommissionPrice: "Tổng số tiền PDV",
  };

  const columnMapping2 = {
    project: "Dự án",
    codeApartment: "Mã căn",
    period: "Đợt",
    codeEmployee: "Mã NV",
    fullNameEmployee: "Tên NV",
    commissionPrice: "Số tiền",
    certificateOrDeposit: "Chứng chỉ/ ký quỹ",
    accountingFromPreviousPeriodOrAdvance:
      "KT do đã ĐK kì trước/Đã tạm ứng/KT khác",
    remainingRevenueAfterAccounting: "PDV còn lại sau KT",
    personalIncomeTax: "Thuế TNCN",
    bonus: "Thưởng nóng",
    remainingRevenueAfterTax: "PDV còn lại sau thuế",
  };

  const onSubmit = async () => {
    try {
      const { dataExport, dataExport2, dataExport3, uniqueSaleOpeningEvents } =
        await commissionAnalystCall.exportCalculatorEstimate({
          projectId,
          bookerId: employeeId,
          apartmentId,
          saleOpeningEventId,
          customerId,
          saleAreaId,
          saleBlockId,
          startTime: startDate,
          endTime: endDate,
          startTimeCreated: startDateCreated,
          endTimeCreated: endDateCreated,
          startCalculatorTime,
          endCalculatorTime,
        });
      if (dataExport?.length === 0) {
        toast.error("Không có dữ liệu nào!");
      } else {
        const dynamicEventColumns = uniqueSaleOpeningEvents?.reduce(
          (acc, item) => {
            acc[item?._id?.toString()] = item.name || "";
            return acc;
          },
          {},
        );

        exportFile(
          dataExport,
          columnMapping,
          "chi_tiet_tinh_phi_dich_vu_tam_tinh.xlsx",
          "Chi tiết PDV",
          dataExport2,
          columnMapping2,
          "PDV theo căn",
          dataExport3,
          {
            codeEmployee: "Mã NV",
            fullNameEmployee: "Tên NV",
            period: "Đợt",
            ...dynamicEventColumns,
            commissionPrice: "Tổng cộng",
            certificateOrDeposit: "Chứng chỉ/ ký quỹ",
            accountingFromPreviousPeriodOrAdvance:
              "KT do đã ĐK kì trước/Đã tạm ứng/KT khác",
            remainingRevenueAfterAccounting: "PDV còn lại sau KT",
            personalIncomeTax: "Thuế TNCN",
            bonus: "Thưởng nóng",
            remainingRevenueAfterTax: "PDV còn lại sau thuế",
          },
          "Tổng PDV",
          // Cột theo đợt mở bán (tiêu đề = tên dự án) là cột tiền -> ép format.
          {
            moneyHeaders: Object.values(dynamicEventColumns || {}).filter(
              Boolean,
            ),
          },
        );
        toast.success("Xuất file thành công");
      }
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"1024px"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Xuất chi tiết phí dịch vụ tạm tính
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>
        <Box padding={"24px"}>
          <Flex
            alignItems={"center"}
            gap={{ base: "16px 32px" }}
            flex={"1"}
            flexWrap={"wrap"}
            w={"100%"}
            paddingBottom={"32px"}
          >
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRange(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày đặt cọc từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startDate && !endDate && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startDateCreated}
                endDate={endDateCreated}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRangeCreated(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày tạo từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startDateCreated && !endDateCreated && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <InputGroup w={"100%"} maxW={"300px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startCalculatorTime}
                endDate={endCalculatorTime}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRangeCalculatorTime(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày tính giao dịch từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startCalculatorTime && !endCalculatorTime && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
            <SearchableSelectMulti
              isShowSearch={true}
              options={apartments}
              // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
              placeholder={"Chọn mã căn"}
              setValue={setApartmentId}
            />
            <SearchableSelectMulti
              isShowSearch={true}
              options={projects}
              // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
              placeholder={"Chọn dự án"}
              setValue={setProjectId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={setSaleOpeningEvents}
              initialSelectedOption={{ key: 0, value: "Chọn đợt mở bán" }}
              // placeholder={"Chọn đợt mở bán"}
              setValue={setSaleOpeningEventId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={customers}
              initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
              setValue={setCustomerId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={employees}
              initialSelectedOption={{
                key: 0,
                value: "Chọn nhân viên tạo",
              }}
              setValue={setEmployeeId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={saleBlocks}
              initialSelectedOption={{ key: 0, value: "Chọn khối" }}
              setValue={setSaleBlockId}
            />
            <SearchableSelect
              isShowSearch={true}
              options={saleAreas}
              initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
              setValue={setSaleAreaId}
            />
          </Flex>
          <Box
            // position={"absolute"}
            w={"100%"}
            // bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
            zIndex={3}
          >
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              <Button
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-option-employee-hover)"}
                borderRadius={"8px"}
                border={"1px solid var(--color-option-employee-hover)"}
                bg={"var(--color-main)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
                onClick={onClose}
              >
                Hủy
              </Button>
              <Button
                onClick={onSubmit}
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Xuất excel
              </Button>
            </Flex>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});
